import React, { lazy, Suspense } from "react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import windowSize from "react-window-size";
import ScrollUpButton from "react-scroll-up-button";
import Clearbit from "../../Clearbit";
import VisualVisitor from "../../VisualVisitor";
import DropDownLayout from "./dropDownLayout";

const HeaderSearchBar = lazy(() =>
  import("../../../../containers/HeaderSearchBar")
);
const HeaderLoginOption = lazy(() =>
  import("../../../../containers/HeaderLoginOption")
);
const AddYourCompany = lazy(() => import("../../Popups/AddYourCompany"));

class HeaderNavigation extends React.Component {
  _isMounted = false;
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      toggleResponsiveBurgerMenu: false,
      viewTopMenuUl: true,
      softwareDD: false,
      serviceDD: false,
      aboutDD: false,
      researchDD: false,
      currentURL: "",
      searchParam: "",
      routeKey: "",
      isAddCompany: false,
      cookies: {},
    };

    this.modifyDropDownArray = this.modifyDropDownArray.bind(this);
    this.setCompanyPopUpFalse = this.setCompanyPopUpFalse.bind(this);
    this.getDropdownClass = this.getDropdownClass.bind(this);
    this.getBurgerMenu = this.getBurgerMenu.bind(this);
    this.getResponsiveBergurMenu = this.getResponsiveBergurMenu.bind(this);
    this.getDisplayOption = this.getDisplayOption.bind(this);
    this.getResponsiveBergurMenuWithState =
      this.getResponsiveBergurMenuWithState.bind(this);
    this.getDisplayOptionWithState = this.getDisplayOptionWithState.bind(this);
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    /**
     * Removing Extranet class on body
     */
    document.body.classList.remove("entBg");

    this.setState({ cookies: this.props.cookies.getAll() });
    if (document.getElementsByTagName("aside").length > 0) {
      document.getElementsByTagName("aside")[0].click();
    }

    if (this.props.windowWidth < 939) {
      this.setState((prevState) => {
        return {
          viewTopMenuUl: false,
          currentURL: this.props.location.pathname,
          searchParam: this.props.location.search,
          routeKey: this.props.location.key,
        };
      });
    } else {
      this.setState({
        currentURL: this.props.location.pathname,
        searchParam: this.props.location.search,
        routeKey: this.props.location.key,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillUpdate() {
    if (this.state.viewTopMenuUl) {
      if (this.props.windowWidth < 939 && this._isMounted) {
        this.setState((prevState) => {
          return {
            viewTopMenuUl: false,
          };
        });
      }
    } else {
      if (this.props.windowWidth >= 939 && this._isMounted) {
        this.setState((prevState) => {
          return {
            viewTopMenuUl: true,
            toggleResponsiveBurgerMenu: false,
            softwareDD: false,
            serviceDD: false,
            aboutDD: false,
            researchDD: false,
          };
        });
      }
    }

    if (this.props.location.key !== this.state.routeKey && this._isMounted) {
      this.setState(
        (prevState) => {
          return { routeKey: this.props.location.key };
        },
        () => {
          if (document.getElementsByTagName("aside").length > 0) {
            if (
              this.props.match.path !== "/vendor/:id/faq" &&
              this.props.match.path !== "/" &&
              this.props.match.path !== "/vendor/:id/customer-videos/popup" &&
              this.props.match.path !== "/vendor/:id/customer-videos"
            ) {
              document.getElementsByTagName("aside")[0].click();
            }
          }
        }
      );
    }
  }

  setCompanyPopUpFalse() {
    if (this._isMounted) {
      this.setState({ isAddCompany: false });
    }
  }

  modifyDropDownArray(arrayObject) {
    const newArray = [];
    const lenthOfPassedArray = arrayObject.length;
    const itemsPerColumn = Math.ceil(lenthOfPassedArray / 4);
    let beginFrom = 0;
    for (let count = 0; count < 4; count++) {
      let subArray = [];
      subArray = arrayObject.slice(beginFrom, beginFrom + itemsPerColumn);
      beginFrom = beginFrom + itemsPerColumn;
      newArray.push(subArray);
    }
    return newArray;
  }

  getDropdownClass = (option) => {
    return this.state[option] ? "dropdown-plus dropdown-open" : "dropdown-plus";
  };

  getBurgerMenu = () => {
    return this.state.toggleResponsiveBurgerMenu
      ? "burger-menu menu-open"
      : "burger-menu";
  };

  getResponsiveBergurMenu = () => {
    return this.state.toggleResponsiveBurgerMenu
      ? { display: "block" }
      : { display: "none" };
  };

  getDisplayOption = () => {
    return this.props.windowWidth > 939
      ? { display: "block" }
      : this.getResponsiveBergurMenu();
  };

  getResponsiveBergurMenuWithState = (stateKey) => {
    return this.state[stateKey] && this.state.toggleResponsiveBurgerMenu
      ? { display: "block" }
      : { display: "none" };
  };

  getDisplayOptionWithState = (stateKey) => {
    return this.props.windowWidth > 939
      ? { display: "block" }
      : this.getResponsiveBergurMenuWithState(stateKey);
  };

  /**
   * If size is less than 939 hide. If size is > 939 show.
   * if size is less than 939 & bugger true then show
   * * if size is less than 939 & bugger false then show
   */

  render() {
    return (
      <React.Fragment>
        {!this.props.location.pathname.includes("/extranet/")
          ? Clearbit()
          : null}
        {!this.props.location.pathname.includes("/extranet/") &&
        !this.props.cookies.getAll().vv_session_id &&
        !window.navigator.userAgent.includes("Prerender")
          ? VisualVisitor()
          : null}
        <ScrollUpButton style={{ display: "none" }} />
        <div className="navik-header header-shadow navik-mega-menu">
          <div className="container-fluid">
            <div className="navik-header-container">
              <div
                className="logo"
                data-mobile-logo="/images/logo_white.webp"
                data-sticky-logo="/images/logo_white.webp"
              >
                <Link to={`/`}>
                  <img
                    src="/images/logo_white.webp"
                    alt="logo"
                    width={175}
                    height={48}
                  />
                </Link>
              </div>
              <div
                className={this.getBurgerMenu()}
                onClick={(e) => {
                  e.preventDefault();
                  this.setState((prevState) => {
                    return {
                      toggleResponsiveBurgerMenu:
                        !prevState.toggleResponsiveBurgerMenu,
                    };
                  });
                }}
              >
                <div className="line-menu line-half first-line"></div>
                <div className="line-menu"></div>
                <div className="line-menu line-half last-line"></div>
              </div>
              <nav className="navik-menu menu-caret submenu-top-border">
                <ul
                  style={
                    this.state.toggleResponsiveBurgerMenu
                      ? { display: "block" }
                      : { display: "none" }
                  }
                >
                  <li className="mega-menu dropdown_menu">
                    <Link to={`/software`}>
                      Software<span></span>
                    </Link>
                    <ul style={this.getDisplayOptionWithState("softwareDD")}>
                      {this.props.webSiteCommonData.common_software_category
                        .length > 0 && (
                        <DropDownLayout
                          columns={this.modifyDropDownArray(
                            this.props.webSiteCommonData.common_software_category.slice(
                              0,
                              20
                            )
                          )}
                        />
                      )}
                      <span className="viewAll">
                        <Link to={`/software`}>See all Categories</Link>
                      </span>
                    </ul>
                    {this.state.toggleResponsiveBurgerMenu &&
                      !this.state.viewTopMenuUl && (
                        <span
                          className={this.getDropdownClass("softwareDD")}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.toggleResponsiveBurgerMenu) {
                              this.setState((prevState) => {
                                return {
                                  softwareDD: !prevState.softwareDD,
                                  serviceDD: false,
                                  aboutDD: false,
                                  researchDD: false,
                                };
                              });
                            }
                          }}
                        ></span>
                      )}
                  </li>
                  <li className="mega-menu dropdown_menu">
                    <Link to={`/services`}>
                      Services<span></span>
                    </Link>
                    <ul style={this.getDisplayOptionWithState("serviceDD")}>
                      {this.props.webSiteCommonData.common_services_category
                        .length > 0 && (
                        <DropDownLayout
                          columns={this.modifyDropDownArray(
                            this.props.webSiteCommonData.common_services_category.slice(
                              0,
                              20
                            )
                          )}
                        />
                      )}
                      <span className="viewAll">
                        <Link to={`/services`}>See all Categories</Link>
                      </span>
                    </ul>
                    {this.state.toggleResponsiveBurgerMenu &&
                      !this.state.viewTopMenuUl && (
                        <span
                          className={this.getDropdownClass("serviceDD")}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.toggleResponsiveBurgerMenu) {
                              this.setState((prevState) => {
                                return {
                                  serviceDD: !prevState.serviceDD,
                                  softwareDD: false,
                                  aboutDD: false,
                                  researchDD: false,
                                };
                              });
                            }
                          }}
                        ></span>
                      )}
                  </li>
                  <li className="dropdown_menu">
                    <Link to={`/about-us`}>
                      About<span></span>
                    </Link>
                    <ul style={this.getDisplayOptionWithState("aboutDD")}>
                      <li>
                        <Link to={`/about-us`}>About Us</Link>
                      </li>
                      <li>
                        <Link to={`/customer-testimonials`}>Our Customers</Link>
                      </li>

                      <li>
                        <Link to={`/press-releases`}>Press Releases</Link>
                      </li>
                      <li>
                        <Link to={`/contact-us`}>Contact Us</Link>
                      </li>
                    </ul>
                    {this.state.toggleResponsiveBurgerMenu &&
                      !this.state.viewTopMenuUl && (
                        <span
                          className={this.getDropdownClass("aboutDD")}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.toggleResponsiveBurgerMenu) {
                              this.setState((prevState) => {
                                return {
                                  aboutDD: !prevState.aboutDD,
                                  softwareDD: false,
                                  serviceDD: false,
                                  researchDD: false,
                                };
                              });
                            }
                          }}
                        ></span>
                      )}
                  </li>
                  <li className="dropdown_menu">
                    <Link to="/customers-success-reports">
                      Resources<span></span>
                    </Link>
                    <ul style={this.getDisplayOptionWithState("researchDD")}>
                      <li>
                        <Link to={`/customers-success-reports`}>
                          Customer Success Reports
                        </Link>
                      </li>
                      <span
                        class="viewAll"
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({ isAddCompany: true });
                        }}
                      >
                        <a href="#add_your_company" className="dd_addcompany">
                          Add Your Company
                        </a>
                      </span>
                    </ul>
                    {this.state.toggleResponsiveBurgerMenu &&
                      !this.state.viewTopMenuUl && (
                        <span
                          className={
                            this.state.researchDD
                              ? "research dropdown-plus dropdown-open"
                              : "research dropdown-plus"
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.toggleResponsiveBurgerMenu) {
                              this.setState((prevState) => {
                                return {
                                  researchDD: !prevState.researchDD,
                                  softwareDD: false,
                                  serviceDD: false,
                                  aboutDD: false,
                                };
                              });
                            }
                          }}
                        ></span>
                      )}
                  </li>
                  <li className="verified-members">
                    <Link to="/vendor-solutions">For Vendors</Link>
                  </li>
                </ul>
              </nav>
              <div className="right_nav">
                <ul>
                  <li className="free_advice">
                    <Link to="/get-free-advice">Get Free Software Advice</Link>
                  </li>
                  <li className="login">
                    <Link to="/extranet/login">Log in</Link>
                  </li>
                </ul>
              </div>
              <Suspense fallback={<></>}>
                <HeaderSearchBar />
              </Suspense>

              {/* <Suspense fallback={<></>}>
                <HeaderLoginOption />
              </Suspense> */}
            </div>
          </div>
          <div className="header-shadow-wrapper"></div>
        </div>
        {this.state.isAddCompany && (
          <Suspense fallback={<></>}>
            <AddYourCompany setCompanyPopUpFalse={this.setCompanyPopUpFalse} />
          </Suspense>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    webSiteCommonData: state.webSiteCommonData,
    tracking: state.webSiteCommonData.common_tracking,
  };
};

const headerScreenSize = windowSize(HeaderNavigation);
const withRouterHeader = withRouter(headerScreenSize);
const withCookiesHeader = withCookies(withRouterHeader);

export default connect(mapStateToProps)(withCookiesHeader);
